import React, { useState, useContext } from 'react'
import AccountMenu from './AccountMenu'
import { NavLink } from 'react-router-dom'
import { ConfigContext } from '../../../context/globalConfig'
import { useSelector, useDispatch } from 'react-redux'
import { setShowMoney } from '../../../redux/actions/accountActions'
import { floatToCurrency } from '../../../helpers/floatToCurrency'
import { getConfig, getCurrency } from 'redux/selectors/configSelectors'
import { getAccount } from 'redux/selectors/accountSelectors'
import { useTranslation } from 'react-i18next'

const UserAccount = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { showMoney } = useSelector(getAccount)
  const { balance } = useSelector(getConfig)
  const { CUSTOMER_CONFIG } = useSelector(getConfig)
  const currencyConfig = useSelector(getCurrency)
  const [menu, setMenu] = useState(false)

  const toggleShowMoneyHandler = () => {
    localStorage.setItem('showMoney', !showMoney ? 'true' : 'false')
    dispatch(setShowMoney(!showMoney))
  }

  /* React.useEffect(() => {
    setShowMoney(localStorage.getItem('showMoney') === 'false' ? false : true)
  }, []) */

  const showMenu = () => setMenu(!menu)

  return (
    <div className="h-account">
      <div className="flex align-middle">
        <div className="h-account__block">
          <div className="flex align-middle align-right">
            <NavLink
              className="font font--white-alpha-05 m-r-10 h-account__nickname"
              to={'/account/history/bet-history'}
            >
              {CUSTOMER_CONFIG.USER_NAME}
            </NavLink>
            <NavLink
              className="fal fa-envelope h-account__mail h-account__mail--active"
              to={'/account/messages/inbox'}
            >
              <span></span>
            </NavLink>
          </div>
          <NavLink className="flex align-middle align-right" to={'/account/balance/deposit'}>
            {showMoney && balance && (
              <p
                className="font font--12 font--green m-r-10 h-account__balance"
                dangerouslySetInnerHTML={{
                  __html: floatToCurrency(
                    parseFloat(balance.total),
                    currencyConfig,
                    true,
                    true
                  ),
                }}
              ></p>
            )}
            <p className="font font--12 font--gold h-account__deposit">
              {t('COMMON.SUBMENU.DEPOSIT')}
            </p>
          </NavLink>
        </div>
        {menu && (
          <div
            className="h-popup__overlay"
            style={{ zIndex: 1 }}
            onClick={showMenu}
            onKeyPress={() => 0}
            role="button"
            tabIndex={0}
          ></div>
        )}
        <div
          className={menu ? 'h-account__avatar h-account__avatar--active' : 'h-account__avatar'}
          onClick={showMenu}
          onKeyPress={() => 0}
          role="button"
          tabIndex={0}
        >
          <a className="h-account__picture">
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M32 16C32 7.17789 24.8221 0 16 0C7.17789 0 0 7.17789 0 16C0 20.6598 2.00378 24.8599 5.19331 27.7865L5.17818 27.7999L5.69716 28.2374C5.71473 28.2522 5.73309 28.2656 5.75141 28.279L5.75143 28.2791C5.7683 28.2914 5.78514 28.3037 5.80131 28.3171C6.07709 28.5457 6.36276 28.7628 6.65367 28.9728C6.74793 29.0409 6.84218 29.1089 6.93818 29.1753C7.24887 29.3894 7.56771 29.5924 7.89353 29.785C7.96443 29.8269 8.03592 29.8675 8.1074 29.9082L8.10764 29.9084C8.46429 30.1114 8.82851 30.3028 9.20145 30.4785C9.20975 30.4824 9.21809 30.4862 9.22646 30.4899C9.23189 30.4924 9.23733 30.4948 9.24276 30.4972L9.24294 30.4972C9.2567 30.5033 9.27046 30.5094 9.28407 30.5158C10.4995 31.0807 11.7969 31.4956 13.1537 31.7405L13.2608 31.7597C13.682 31.8324 14.1079 31.8906 14.5391 31.9296C14.5656 31.932 14.5921 31.9339 14.6186 31.9358C14.6446 31.9376 14.6706 31.9395 14.6967 31.9418C15.1261 31.9773 15.5601 32 16 32C16.4358 32 16.8657 31.9773 17.2928 31.943C17.3199 31.9407 17.3469 31.9388 17.374 31.9369C17.401 31.935 17.4281 31.9331 17.4551 31.9308C17.8828 31.8918 18.3052 31.8353 18.7223 31.7638L18.7675 31.7558C18.7818 31.7532 18.796 31.7506 18.8102 31.748C18.8172 31.7467 18.8242 31.7453 18.8311 31.744C20.1676 31.5043 21.4464 31.0988 22.6461 30.5484C22.6645 30.5399 22.6829 30.5317 22.7014 30.5234C22.7274 30.5118 22.7535 30.5001 22.7793 30.4879C23.1383 30.3191 23.4892 30.137 23.833 29.9433C23.9185 29.895 24.0035 29.8461 24.0884 29.7961C24.4015 29.6116 24.7092 29.4191 25.0083 29.2143C25.0946 29.1555 25.1793 29.0941 25.2644 29.0325L25.2645 29.0325L25.3277 28.9868C25.5831 28.8029 25.8339 28.6132 26.0777 28.4148C26.1019 28.3953 26.127 28.3769 26.1521 28.3585L26.1521 28.3584C26.1829 28.3358 26.2137 28.3133 26.2429 28.2886L26.7753 27.8441L26.7596 27.8307C29.977 24.903 32 20.6836 32 16ZM1.16364 16C1.16364 7.81905 7.81905 1.16364 16 1.16364C24.1809 1.16364 30.8364 7.81905 30.8364 16C30.8364 20.4084 28.9018 24.3718 25.8391 27.0912C25.6681 26.9731 25.4959 26.8672 25.3196 26.7788L20.3933 24.3159C19.9511 24.0948 19.6765 23.6503 19.6765 23.1564V21.4359C19.7905 21.2951 19.911 21.1357 20.0355 20.9606C20.6732 20.0599 21.1846 19.058 21.5575 17.9799C22.2947 17.6297 22.7706 16.8954 22.7706 16.0663V14.0038C22.7706 13.4993 22.5856 13.01 22.2545 12.6255V9.91011C22.2848 9.60814 22.3919 7.904 21.159 6.49833C20.0867 5.27418 18.3511 4.65455 16 4.65455C13.6489 4.65455 11.9133 5.27418 10.841 6.49775C9.60814 7.90342 9.7152 9.60756 9.74545 9.90953V12.6249C9.41498 13.0095 9.22938 13.4988 9.22938 14.0032V16.0657C9.22938 16.7063 9.5168 17.3039 10.009 17.7071C10.4803 19.5532 11.4502 20.9507 11.8086 21.4243V23.1081C11.8086 23.5828 11.5497 24.0192 11.1325 24.2473L6.53207 26.7567C6.38545 26.8364 6.24 26.9295 6.09455 27.0336C3.06967 24.3153 1.16364 20.3764 1.16364 16ZM24.0826 28.4317C24.2927 28.295 24.4998 28.1519 24.7034 28.0041C24.7255 27.9881 24.7478 27.9723 24.7701 27.9565C24.8111 27.9275 24.8522 27.8985 24.8925 27.8679C24.8617 27.8516 24.8308 27.8353 24.7994 27.8196L19.8732 25.3568C19.0342 24.9379 18.5129 24.0943 18.5129 23.1564V21.0042L18.6572 20.8396C18.7846 20.6935 18.9329 20.5027 19.0854 20.2874C19.7056 19.4112 20.1943 18.4262 20.5376 17.3597L20.6307 17.0717L20.9199 16.9827C21.3248 16.8576 21.607 16.4812 21.607 16.0663V14.0038C21.607 13.7332 21.4918 13.4807 21.2829 13.2922L21.0909 13.1188L21.0961 9.80189L21.0962 9.80131C21.0999 9.76666 21.2503 8.35559 20.274 7.25295C19.4304 6.30109 17.9933 5.81818 16 5.81818C13.9991 5.81818 12.5574 6.30516 11.7161 7.264C10.7305 8.38749 10.9021 9.78676 10.9039 9.80073L10.9091 9.87695V13.1177L10.7171 13.2911C10.5076 13.4801 10.393 13.7321 10.393 14.0026V16.0652C10.393 16.3916 10.5606 16.6941 10.8404 16.8751L11.0388 17.0036L11.0918 17.234C11.5671 19.3059 12.825 20.8361 12.8378 20.8506L12.9716 21.0124L12.9722 23.1081C12.9722 24.0093 12.4806 24.8372 11.6893 25.2689L7.08887 27.7783L7.03302 27.8097C7.04611 27.8196 7.05891 27.8298 7.07171 27.84C7.08451 27.8502 7.09731 27.8604 7.1104 27.8703C7.36407 28.0605 7.62473 28.2403 7.88887 28.4131C7.97265 28.4678 8.05702 28.5219 8.14196 28.5754C8.4288 28.7546 8.71971 28.9263 9.01702 29.0851C9.0428 29.0991 9.06902 29.1124 9.09527 29.1257C9.11168 29.134 9.1281 29.1423 9.14444 29.1508C9.47025 29.3201 9.80015 29.4807 10.1364 29.6256L10.144 29.6291C10.4995 29.7815 10.8614 29.9194 11.2273 30.0439C11.2387 30.0477 11.2502 30.0516 11.2617 30.0556C11.2732 30.0595 11.2847 30.0634 11.296 30.0672C12.0332 30.3145 12.7901 30.5036 13.5593 30.6321L13.6081 30.6409C13.9718 30.7002 14.3389 30.7439 14.7078 30.7764C14.7552 30.7808 14.803 30.7842 14.8508 30.7876C14.8664 30.7887 14.8819 30.7898 14.8975 30.791C15.2634 30.8183 15.6311 30.8364 16 30.8364C16.3648 30.8364 16.7279 30.8189 17.0892 30.7916C17.1046 30.7905 17.1199 30.7894 17.1353 30.7883C17.1849 30.7849 17.2342 30.7815 17.2835 30.777C17.6489 30.745 18.0131 30.7025 18.3744 30.6438C18.3818 30.6426 18.3891 30.641 18.3965 30.6396C18.3996 30.6391 18.4027 30.6385 18.4058 30.638C18.7898 30.5745 19.1715 30.4972 19.5485 30.4041C19.5497 30.4041 19.5508 30.4035 19.552 30.4035C19.9255 30.311 20.295 30.2033 20.6598 30.0823C20.6848 30.0742 20.7092 30.0655 20.7337 30.0573C21.4301 29.8228 22.1079 29.5343 22.7631 29.1985C22.7861 29.1867 22.8091 29.1751 22.8321 29.1634C22.8724 29.1429 22.9127 29.1225 22.9527 29.1014C23.2378 28.9501 23.5171 28.7884 23.7917 28.6185C23.8797 28.5638 23.9659 28.5077 24.0523 28.4515L24.0826 28.4317Z"
                fill="white"
              ></path>
            </svg>
          </a>
          <AccountMenu
            active={menu}
            showMenu={showMenu}
            {...{ showMoney }}
            {...{ toggleShowMoneyHandler }}
          />
        </div>
      </div>
    </div>
  )
}

export default UserAccount
